import { faUser } from "@fortawesome/pro-solid-svg-icons"
import { Grid, ListItem, ListItemAvatar, ListItemText, useTheme } from "@mui/material"
import PaperBox from "components/PaperBox"
import { CircleIcon } from "components/icons/CircleIcon"
import { StyledBlackText, StyledGrid, StyledTypography } from "./OverviewCard.styled"

export const OverviewCard = ({ card }) => {
  const theme = useTheme()
  return (
    <StyledGrid item>
      <PaperBox paddingX={3} paddingY={3} marginY={0}>
        <ListItem disableGutters>
          <ListItemAvatar>
            <CircleIcon
              icon={card.icon ? card.icon : faUser}
              backgroundColor={theme.palette.primary[300]}
              color={theme.palette.primary[900]}
              size="lg"
              sx={{ marginRight: "15px" }}
            />
          </ListItemAvatar>
          <ListItemText>
            <Grid container justifyContent="space-between" alignItems="center">
              <Grid item>
                <StyledTypography color="secondary" variant="bodyMedium">
                  {card.title}
                </StyledTypography>
                <StyledBlackText variant="h2">{card.value}</StyledBlackText>
              </Grid>
            </Grid>
          </ListItemText>
        </ListItem>
      </PaperBox>
    </StyledGrid>
  )
}
